import styled from 'styled-components';

export const Container = styled.div`
  font-family: Manrope;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: -0.01em;
  text-align: left;
  color: white;
  text-align: center;
`;